import * as React from 'react';
import { Grid } from 'semantic-ui-react';
import Selection from '../../../shared/component/selection_component';
import TabbedMultiSelect from '../../../admin/constants/component/tabbed_multi_select';
import { AppliedModifierFormData, AppliedModifierDropdownData, ChargeByItem } from '../../constant/applied_modifiers_constants';
import * as AppliedModifiersConstants from '../../constant/applied_modifiers_constants';
import { UI_CONSTANTS } from '../../constant/applied_modifiers_constants';

export interface ApplySectionProps {
  formData: AppliedModifierFormData;
  onFieldChange: (field: string, value: any) => void;
  markFieldForRequiredValidation: (fieldName: string) => boolean;
  markFieldForValidation: (fieldName: string) => boolean;
  dropdownData: AppliedModifierDropdownData;
  isSaveButtonDisabled: boolean;
  getMemoizedToChargeByValues: () => any[];
}

export const ApplySection: React.FC<ApplySectionProps> = ({
  formData,
  onFieldChange,
  markFieldForRequiredValidation,
  markFieldForValidation,
  dropdownData,
  isSaveButtonDisabled,
  getMemoizedToChargeByValues
}) => {
  const onChangeModifier = (value: string, e: any) => {
    onFieldChange('modifier', value);
  };

  const onChangeToChargeBy = (value: ChargeByItem[], e: any) => {
    onFieldChange('to_charge_by', value);
  };

  return (
    <>
      <Grid.Row>
        <Grid.Column width={16}>
          <label className={UI_CONSTANTS.CSS_CLASSES.APPLIED_MODIFIERS_UI_SECTION_LABEL}>
            <span>
              {UI_CONSTANTS.LABELS.APPLY_SECTION}
            </span>
          </label>
        </Grid.Column>
        <Grid.Column width={8}>
          <label>
            {UI_CONSTANTS.LABELS.MODIFIER}
            <span className={markFieldForRequiredValidation(AppliedModifiersConstants.field_identifier.modifier) ? UI_CONSTANTS.CSS_CLASSES.REQUIRED_ALERT : UI_CONSTANTS.CSS_CLASSES.REQUIRED_ALERT_NORMAL}>
              {UI_CONSTANTS.LABELS.REQUIRED_INDICATOR}
            </span>
          </label>
          <Selection
            id={AppliedModifiersConstants.field_identifier.modifier}
            name={AppliedModifiersConstants.field_identifier.modifier}
            options={dropdownData.modifier_list}
            defaultValue={formData.modifier}
            isRequired={markFieldForValidation(AppliedModifiersConstants.field_identifier.modifier)}
            onChange={onChangeModifier}
            data-testid={AppliedModifiersConstants.field_identifier.modifier}
          />
        </Grid.Column>
        <Grid.Column width={8}>
          <label>
            To Charge by
            <span className={markFieldForRequiredValidation(AppliedModifiersConstants.field_identifier.to_charge_by) ? "req-alert" : 'req-alert_normal'}> (required)</span>
          </label>
          <TabbedMultiSelect
            id={AppliedModifiersConstants.field_identifier.to_charge_by}
            defaultValues={getMemoizedToChargeByValues()}
            sources={dropdownData.to_charge_by_list}
            onChange={onChangeToChargeBy}
            required={markFieldForValidation(AppliedModifiersConstants.field_identifier.to_charge_by)}
            disabled={isSaveButtonDisabled}
            data-testid={AppliedModifiersConstants.field_identifier.to_charge_by}
          />
        </Grid.Column>
      </Grid.Row>
    </>
  );
};
